export const toJson = (stringToJson) => {
    return JSON.parse(JSON.stringify(stringToJson))
}
